import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ICalendarProps } from './types';
import dayjs, { Dayjs } from 'dayjs';

export const Calendar: React.FC<ICalendarProps> = ({
  inputFormat = 'DD/MM/YYYY',
  onChange,
  textFieldProps,
  value,
  ...props
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        onChange={(date: Dayjs | Date | null) => {
          const today = dayjs();
          const currentHour = today.hour();
          const currentMinute = today.minute();
          const currentSecond = today.second();
          const currentMillisecond = today.millisecond();

          const dateWithTime = dayjs(date)
            .set('hour', currentHour)
            .set('minute', currentMinute)
            .set('second', currentSecond)
            .set('millisecond', currentMillisecond);

          onChange(dateWithTime);
        }}
        value={value}
        inputFormat={inputFormat}
        renderInput={params => <TextField {...params} {...textFieldProps} />}
        {...props}
      />
    </LocalizationProvider>
  );
};
